import React from 'react'

import AbsolutePageTemplate from '../../../../components/templates/AbsolutePageTemplate'
import PageContent from '../_shared/PageContent'
import PageHeader from '../_shared/PageHeader'
import ServiceOrderLoader from '../_load/ServiceOrderLoader'
import AssetsFieldValuesLoader from '../_load/AssetsFieldValuesLoader'

const TemplateRaiaPdfPage = ({ id, templateId }) => {
  return (
    <AbsolutePageTemplate>
      <ServiceOrderLoader id={id}>
        <AssetsFieldValuesLoader>
          <PageHeader templateId={parseInt(templateId)} />
          <PageContent />
        </AssetsFieldValuesLoader>
      </ServiceOrderLoader>
    </AbsolutePageTemplate>
  )
}

export default TemplateRaiaPdfPage
